export default __webpack_public_path__ + "imgs/gongzhonghao.00004b3c.jpg";